import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedProducts from './components/FeaturedProducts';
import LatestArticles from './components/LatestArticles';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黄油小熊官方落地页',
    description: '黄油小熊是当下最受欢迎的治愈系IP形象之一，集萌系外观与暖心设计于一体。汇聚周边产品、联名款式、收藏攻略及购买渠道。',
    url: 'https://butterbear.com/',
    mainEntity: {
      '@type': 'Organization',
      name: '黄油小熊',
      description: '黄油小熊是当下最受欢迎的治愈系IP形象之一，集萌系外观与暖心设计于一体。',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <main>
        <HeroSection />
        <CategoryShowcase />
        <FeaturedProducts />
        <LatestArticles />
        <NewsletterSection />
      </main>
    </>
  );
}